enum DpkType {

    OpenPosition = "openPosition",
    openposition = "openposition",
    OpenDeposit = "opendeposit",
    Deposit = "deposit",
    OpenUploadDocument = "openuploaddocument"
}

namespace DpkType {

    export function deserialize(v: string): DpkType {
        if (v) {
            switch (v) {
                case "dpk:openPosition":
                    return DpkType.OpenPosition;
                case "dpk:openposition":
                    return DpkType.openposition;
                case "dpk:opendeposit":
                    return DpkType.OpenDeposit;
                case "dpk:deposit":
                    return DpkType.Deposit;
                case "dpk:openuploaddocument":
                    return DpkType.OpenUploadDocument;
            }
        }
        return null;
    }
}

export {DpkType};
